import http from './request';

// 结算，生成订单信息
const createOrder = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/order/confirm',
  data,
  showLoading: true,
  loadingMask: true,
});

// 提交订单
const submitOrder = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/order/submit',
  data,
  showLoading: true,
  loadingMask: true,
});

// 预支付
const createPrePay = (params) => http({
  app: 'banyanSi',
  method: 'get',
  url: '/institution-hospital-server/mini/pay/createPrePay',
  params,
  showLoading: true,
  loadingMask: true,
});

// 获取订单列表
const getOrderList = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/order/pageOrder',
  data,
  showLoading: true,
  loadingMask: true,
});

// 获取订单详情
const getOrderDetail = (params) => http({
  app: 'banyanSi',
  method: 'get',
  url: '/institution-hospital-server/mini/order/detail',
  params,
  showLoading: true,
  loadingMask: true,
});

// 获取退款理由
const getRefundReason = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/order/refund/reason',
  data,
});

// 申请退款
const applyRefund = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/order/seekRefund',
  data,
  showLoading: true,
  loadingMask: true,
});

// 取消订单
const cancelOrder = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/order/cancel',
  data,
  showLoading: true,
  loadingMask: true,
});

// 获取退款订单列表
const getRefundList = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/order/refund/list',
  data,
  showLoading: true,
  loadingMask: true,
});

// 获取退款订单详情
const getRefundDetail = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/order/refund/detail',
  data,
});

// 获取预约订单列表
const getReservationList = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/reserve/page',
  data,
});

// 获取预约订单详情
const getReservationDetail = (params) => http({
  app: 'banyanSi',
  method: 'get',
  url: '/institution-hospital-server/mini/reserve/detail',
  params,
});

// 新增预约信息
const addReservation = (data) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/institution-hospital-server/mini/reserve/add',
  data,
});

export {
  createOrder,
  submitOrder,
  createPrePay,
  getOrderList,
  getOrderDetail,
  getRefundReason,
  applyRefund,
  cancelOrder,
  getRefundList,
  getRefundDetail,
  getReservationList,
  getReservationDetail,
  addReservation
};
